import axios from '@axios'

export default {
  load() {
    return axios.get('/adm/cliente?page=0&size=10&sort=nome,asc')
  },
  edit(data) {
    return axios.put(`/adm/cliente/${data.id}`, data)
  },
}
